import { createContext, useContext, useState } from 'react'

export const FeatureFlagContext = createContext({})
export const FeatureFlagProvider = ({ children }) => {
  const [variations, _setVariations] = useState({})
  const [featureFlags, _setFeatureFlags] = useState({})

  const setVariation = (experimentSection, variation) => {
    _setVariations((state) => ({ ...state, [experimentSection]: variation }))
  }

  const setVariations = (variations) => {
    _setVariations((state) => ({
      ...state,
      ...variations.reduce(
        (result, { experimentSection, variation }) => ({
          ...result,
          [experimentSection]: variation,
        }),
        {}
      ),
    }))
  }

  const setFeatureFlags = (featureFlags = {}) => {
    _setFeatureFlags(
      Object.keys(featureFlags).reduce((prev, curr) => {
        if (featureFlags[curr] !== 'off') {
          return { ...prev, [curr]: featureFlags[curr] }
        }

        return { ...prev }
      }, {})
    )
  }

  const getExperimentVariation = (
    experimentSection,
    defaultValue = 'control'
  ) => {
    return variations[experimentSection] || defaultValue
  }

  const getFeatureFlags = () => {
    return featureFlags
  }

  const getFeatureFlag = (flag) => {
    return featureFlags[flag] || 'control'
  }

  return (
    <FeatureFlagContext.Provider
      value={{
        setFeatureFlags,
        setVariation,
        setVariations,
        getExperimentVariation,
        variations,
        getFeatureFlags,
        getFeatureFlag,
      }}
    >
      {children}
    </FeatureFlagContext.Provider>
  )
}
export const useFeatureFlags = () => useContext(FeatureFlagContext)

export const ABTestingContext = createContext({})
export const useABTestingVersion = () => useContext(ABTestingContext)
